import { render } from "./IconPrev.vue?vue&type=template&id=534a91ee"
import script from "./IconPrev.vue?vue&type=script&lang=js"
export * from "./IconPrev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__